import { useSelector } from 'react-redux'

import { selectTrafficProfiles } from '@/features/domain/traffic'

export const useTrafficProfiles = () => {
  const trafficProfiles = useSelector(selectTrafficProfiles)

  return trafficProfiles
}
